import Vue from 'vue';
import VueI18n from 'vue-i18n';

import CN from './zh-CN.json'
import US from './en-US.json'

import iView from 'iview';
import en from 'iview/dist/locale/en-US';
import zh from 'iview/dist/locale/zh-CN';

Vue.use(VueI18n);

const navLang = navigator.language

const localLang = (navLang === 'zh-CN' || navLang === 'en-US') ? navLang : false



const i18n = new VueI18n({
    locale: window.localStorage.getItem('language') || localLang || 'zh-CN', 
    messages: {
      'en-US': Object.assign(US, en),  //将自己的英文包和iview提供的结合
      'zh-CN': Object.assign(CN, zh)  //将自己的中文包和iview提供的结合
    }
});
Vue.use(iView, {
    i18n: (key, value) => i18n.t(key, value)
})
export default i18n


// WEBPACK FOOTER //
// ./src/language/index.js